import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { AppSettings } from 'src/app/app.settings';
import { UntypedFormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SearchCustomerService } from 'src/app/core/services/search-customer.service';
import { Settings } from 'src/app/app.settings.model';
import { filter } from 'rxjs/operators';
import { CustomerSearchResult } from 'src/app/core/models/customer-search-result';


@Component({
  selector: 'app-search-customer',
  templateUrl: './search-customer.component.html',
  styleUrls: ['./search-customer.component.scss']
})
export class SearchCustomerComponent implements OnInit {

  // public form: FormGroup;
  public settings: Settings;
  public error: string;

  @Input() selectedItem: CustomerSearchResult;
  @Output() selected = new EventEmitter<CustomerSearchResult>();
  results: CustomerSearchResult[];
  loading: boolean;
  totalFoundMessage = '';


  constructor(
    public appSettings: AppSettings,
    public fb: UntypedFormBuilder,
    public router: Router,
    public translate: TranslateService,
    public searchService: SearchCustomerService) {

    this.settings = appSettings.settings;
  }

  ngOnInit() {
      
  }

  ngAfterViewInit() {
    this.settings.loadingSpinner = false;
  }

  updateResults(results: CustomerSearchResult[]) : void{
    this.results = results;
    if (this.results.length === 0) {
      this.totalFoundMessage = this.translate.instant('SEARCH.NOT-FOUND');
    } else {      
      this.totalFoundMessage = this.translate.instant('SEARCH.FOUND-X-PATIENTS', { num: this.results.length});
    }
  }

  onSelect(customerData: CustomerSearchResult) : void{
    // search-custome component
    this.selectedItem = customerData; 
    this.selected.emit(customerData);
    this.router.navigate(['/patient-details', customerData.EntityID]);
  }

}
